// extracted by mini-css-extract-plugin
export default {"empty-cart":"mAZF70It--EmptyCartPage_empty-cart__fhyi+","emptyCart":"mAZF70It--EmptyCartPage_empty-cart__fhyi+"};